export const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://nodjswebhook.onrender.com'
    : 'http://localhost:3002');
